




























import { Vue, Component, Prop } from "vue-property-decorator";
import { Condition as ICondition } from "@/api-v2/agent/models/condition";
import CustomTable from "@/components/form/CustomTable.vue";
import CustomButton from "@/components/form/CustomButton.vue";
import ConditionTableItem from "@/components/condition/ConditionTableItem.vue";

@Component({
  components: { ConditionTableItem, CustomButton, CustomTable }
})
export default class ConditionTable extends Vue {
  @Prop({ default: 0 }) count!: number;
  @Prop({ default: () => [] }) conditions!: ICondition[];

  get isShowAddMoreButton(): boolean {
    return this.conditions?.length < (this.count ?? 0);
  }

  removeConditionHandler(condition: ICondition) {
    this.$emit("remove", condition);
  }
}
